<template>
    <v-card outlined class="pa-2 my-4" style="background-color: #fff8e1" v-if="showWarningBox()"> 
      <v-row class="warning-header" align="center" @click="toggleExpand">
        <v-col cols="auto" class="mx-3">
          <h2 style="color:black;">
            {{ $t("deforestation.complianceRiskWarnings") }} ({{ warningCount }})
            <v-tooltip top color="00BD73" max-width="350">
              <template v-slot:activator="{ on, attrs }">
                <v-icon class="icon-with-background primary--text" style="color:#0EBF67" v-bind="attrs" v-on="on">
                  mdi-alert-circle
                </v-icon>
              </template>
              <span>{{ $t("deforestation.complianceRiskWarningsInfo") }}</span>
            </v-tooltip>
          </h2>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="auto">
          <v-btn icon>
            <v-icon>{{ isExpanded ? "mdi-menu-up" : "mdi-menu-down" }}</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-expand-transition>
        <div v-show="isExpanded">
          <ul class="ma-3">
            <li>
              <p> <span class="warning-title font-weight-bold" color="primary"> Local DB Verification
                  : </span>   <span>{{ warningCount }}</span> <span>{{ $t("deforestation.issueFound") }}</span></p>
            </li>
          </ul>
        </div>
      </v-expand-transition>
    </v-card>
  </template>
  
  <script>
  export default {
    props: {
      warningCount:{
        required:true,
        type:Number
      }
    },
    computed: {
    },
    data() {
      return {
        isExpanded: false,
      };
    },
    methods: {
       showWarningBox() {
        return this.warningCount
      },
      toggleExpand() {
        this.isExpanded = !this.isExpanded;
      },
    },
  };
  </script>
  <style scoped lang="scss">
  .warning-title {
    font-size: 16px;
    font-weight: 700;
    text-decoration: underline ;
    color: var(--primary-color);
    text-transform: capitalize;
    cursor: pointer;
  }
  .warning-header{
    cursor: pointer;
  }
  .info-icon{
    margin-left: 10px;
    margin-bottom: 10px;
  }
  </style>